import type { UserMarkerVariant } from '@/types/mapData'
import type { LiveStatus } from '@/types/trackingStatus'

// Pure mapping used by both the big monitor map and the card mini-map so they
// share one source of truth for which statuses get which marker visual.
export function variantForStatus(status: LiveStatus): UserMarkerVariant | null {
    switch (status) {
        case 'working_moving':
            return 'moving'
        case 'working_on_site':
            return 'on_site'
        case 'working_idle':
            return 'idle'
        case 'working_untracked':
            return 'idle'
        // Late/early clock-ins borrow the on_site marker — they're on the
        // clock and tracking, but we don't have fresh enough movement data
        // to confidently pick moving vs idle, so the neutral filled-circle
        // treatment reads best.
        case 'after_hours_working':
        case 'before_hours_working':
            return 'on_site'
        case 'off_hours':
            return 'off'
        default:
            return null
    }
}
